import { Skeleton, Stack } from "@mantine/core";

export default function ContactFormSkeleton() {
  return (
    <Stack gap={"lg"}>
      <Skeleton height="3rem" animate />
      <Skeleton height="3rem" animate />
      <Skeleton height="10rem" animate />
      <Skeleton
        height="2.25rem"
        width="5rem"
        mt={"3rem"}
        mr={0}
        ml={"auto"}
        animate
      />
    </Stack>
  );
}
